import React, { useRef, useState } from 'react';
import {
  Avatar,
  Button,
  CssBaseline,
  Grid,
  Typography,
  // makeStyles,
  Container,
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import NotificationAlert from 'react-notification-alert';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { db } from './db/config';
import * as firebase from 'firebase';
import { ErrorOutlineSharp } from '@mui/icons-material';
import * as yup from 'yup';
import { Input, FormGroup, Form } from 'reactstrap';

export default function SignIn(props) {
  const pathOptions = [
    {
      value: 'Dashboard',
      path: '/dashboard',
    },
    {
      value: 'User_Management',
      path: '/tables',
    },
    {
      value: 'Student_Management',
      path: '/student',
    },
    {
      value: 'Teacher_Management',
      path: '/teacher',
    },
    {
      value: 'Book_Management',
      path: '/book',
    },
    {
      value: 'Quiz_Management',
      path: '/quiz',
    },
    {
      value: 'Session_Management',
      path: '/session-managemnt',
    },
    {
      value: 'Subject_Management',
      path: '/subject-managemnt',
    },
    {
      value: 'Package_Management',
      path: '/package',
    },
    // {

    //     value:"Transaction_Management",
    //     path: "/transaction",

    // },
    {
      value: 'Chat',
      path: '/chat',
    },
    {
      value: 'Reports',
      path: '/',
    },
  ];

  // let loginSchema = yup.object().shape({
  //   email: yup.string().email().required(),
  //   password: yup.string().required(),
  // });

  const navigate = useNavigate();
  const notifi = useRef();

  const notify = (msg, err) => {
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };

  const loginSchema = yup.object().shape({
    email: yup
      .string()
      .email('Invalid email format')
      .required('Email is required'),
    password: yup.string().required('Password is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const classes = {
    body: {
      width: '50%',
      height: '100%',
      minHeight: '100vh',
    },
    root: {
      // marginLeft: theme.spacing(5),
    },
    paper: {
      // marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      // margin: theme.spacing(1),
      // backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      // marginTop: theme.spacing(1),
    },
    submit: {
      // margin: theme.spacing(3, 0, 2),
    },
  };
  // const { register, handleSubmit, errors } = useForm();
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [visible, setVisible] = useState(false);

  const onSubmit = (data) => {
    console.log(data);
    let email = data.email;
    let password = data.password;
    if (email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      setEmailError('');
      setPasswordError('Email is not in valid format');
      return;
    } else {
      setPasswordError('');
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(function (user) {
          db.collection('zSystemUsers')
            .doc(user.user.uid)
            .get()
            .then((querySnapshot) => {
              let data = querySnapshot.data();
              if (data.isTeacher) return navigate('/admin/session-managemnt');
              let currentPermission = pathOptions.filter((item) =>
                data.permissions.find((v) => v.value == item.value)
              );
              console.log('currentPermission', currentPermission);
              if (currentPermission.length !== 0) {
                navigate(`/admin${currentPermission[0].path}`);
              }
              console.log('user is sign inned');
            })
            .catch((err) => console.log(err));
        })
        .catch(function (error) {
          setEmailError('Wrong email or password');
          notify(error.message, true);
          console.log(error.code);
          console.log(error.message);
        });
    }
  };

  // const history = useNavigate();

  //  firebase.auth().onAuthStateChanged(function(user){
  //    if(user){
  //      console.log("my user is ",user)
  //      history.push('/admin/dashboard')
  //      return
  //    }
  //  })

  return (
    <div
      style={{
        overflow: 'hidden',
        height: window.innerHeight,
        width: window.innerWidth,
        background: `url(${'https://crimsonbeans-my.sharepoint.com/personal/honey_yadav_crimsonbeans_co_in/Documents/Microsoft%20Teams%20Chat%20Files/back.jpg'})`,
      }}
    >
      <NotificationAlert ref={notifi} />

      <Container
        className={classes.root}
        component='main'
        maxWidth='xs'
        style={{ margin: 'auto', marginTop: 150 }}
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component='h1' variant='h2' style={{ color: 'black' }}>
            Sign in
          </Typography>
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            style={{ marginTop: '20px' }}
          >
            {/* Email Input */}
            <FormGroup style={{ marginBottom: '15px' }}>
              <input
                type='email'
                name='email'
                placeholder='Email'
                {...register('email')}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              {errors.email && (
                <Typography style={{ color: '#f44336', marginTop: '5px' }}>
                  {errors.email.message}
                </Typography>
              )}
            </FormGroup>

            {/* Password Input */}
            <FormGroup style={{ marginBottom: '15px', position: 'relative' }}>
              <input
                type={visible ? 'text' : 'password'}
                name='password'
                placeholder='Password'
                {...register('password')}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              {visible ? (
                <VisibilityIcon
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '10px',
                    cursor: 'pointer',
                  }}
                  onClick={() => setVisible((prev) => !prev)}
                />
              ) : (
                <VisibilityOffIcon
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '10px',
                    cursor: 'pointer',
                  }}
                  onClick={() => setVisible((prev) => !prev)}
                />
              )}
              {errors.password && (
                <Typography style={{ color: '#f44336', marginTop: '5px' }}>
                  {errors.password.message}
                </Typography>
              )}
            </FormGroup>

            {/* Submit Button */}
            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              style={{ marginTop: '10px', padding: '10px 0' }}
            >
              Sign In
            </Button>
          </form>
          {/* <Form
            // className={classes.form}
            // noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <Grid item xs>
                {emailError !== '' && (
                  <p
                    style={{
                      color: '#ff0066',
                      textAlign: 'center',
                      marginTop: 20,
                    }}
                  >
                    {emailError}
                  </p>
                )}
              </Grid>
            </Grid>
            <FormGroup
              style={{
                marginBottom: 35,
                marginTop: emailError === '' ? 25 : 5,
              }}
            >
              <Input
                // style={{  }}
                name='email'
                placeholder='Email'
                type='email'
                {...register('email')}
                style={{ color: 'black', background: '#fff', marginTop: 20 }}
              />
              {passwordError !== '' && (
                <p style={{ color: '#ff0066', textAlign: 'center' }}>
                  {passwordError}
                </p>
              )}*/}
          {/* {emailError!==" "&&<p style={{color:'red'}}>{emailError}</p>} */}
          {/* </FormGroup>
            <FormGroup>
              <Input
                // style={{  }}
                name='password'
                placeholder='Password'
                type={visible ? 'text' : 'password'}
                {...register('password')}
                style={{ color: 'black', background: '#fff', marginTop: 50 }}
              />
              {visible ? (
                <VisibilityIcon
                  style={{
                    position: 'absolute',
                    right: '0px',
                    margin: '10px',
                    cursor: 'pointer',
                    top: -3,
                  }}
                  onClick={() => setVisible((prev) => !prev)}
                />
              ) : (
                <VisibilityOffIcon
                  style={{
                    position: 'absolute',
                    right: '0px',
                    margin: '10px',
                    cursor: 'pointer',
                    top: -3,
                  }}
                  onClick={() => setVisible((prev) => !prev)}
                />
              )}
              {/* {passwordError!=="" && <p style={{color:'red'}}>{passwordError}</p>} */}
          {/*  </FormGroup>

            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
            >
              Sign In
            </Button>
          </Form> */}
        </div>
      </Container>
    </div>
  );
}
{
  /* <Box mt={8}>
        <Copyright />
        </Box> */
}
{
  /* <Link href="#" variant="body2">
                  Forgot password?
                </Link> */
}

{
  /* <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid> */
}

{
  /* <TextField
              variant="outlined"
              margin="normal"
              inputRef={register({required:true,})}
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              error={errors.email?true:false}
              
            /> */
}
{
  /* {errors.email && errors.email.message} */
}
{
  /* <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              inputRef={register({required:true,minLength:6})}
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              error={errors.password?true:false}
              />
  
            {errors.password&&<p>{errors.password}</p>} */
}
{
  /* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */
}
